// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';


import enCommon from './app/Translations/en/common.json';
import enHome from './app/Translations/en/home.json';
import enAbout from './app/Translations/en/about.json';
import enContact from './app/Translations/en/contact.json';
import enAuth from './app/Translations/en/auth.json'

import deCommon from './app/Translations/de/common.json';
import deHome from './app/Translations/de/home.json';
import deAbout from './app/Translations/de/about.json';
import deContact from './app/Translations/de/contact.json';
import deAuth from './app/Translations/de/auth.json'

import esCommon from './app/Translations/es/common.json';
import esHome from './app/Translations/es/home.json';
import esAbout from './app/Translations/es/about.json';
import esContact from './app/Translations/es/contact.json';
import esAuth from './app/Translations/es/auth.json';

import frCommon from './app/Translations/fr/common.json';
import frHome from './app/Translations/fr/home.json';
import frAbout from './app/Translations/fr/about.json';
import frContact from './app/Translations/fr/contact.json';
import frAuth from './app/Translations/fr/auth.json';
// Resources object banayein
const resources = {
  en: {
    common: enCommon,
    home: enHome,
    about:enAbout,
    contact:enContact,
    auth:enAuth,
  },
  de: {
    common: deCommon,
    home: deHome,
    about:deAbout,
    contact:deContact,
    auth:deAuth,
  },
  es:{
    common: esCommon,
    home: esHome,
    about: esAbout,
    contact:esContact,
    auth:esAuth,
  },
  fr:{
    common: frCommon,
    home: frHome,
    about: frAbout,
    contact:frContact,
    auth:frAuth,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'es', 'fr'],
    ns: [ 'common', 'home', 'about', 'contact', 'auth'],
    defaultNS: 'common',
    
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      lookupLocalStorage: 'selectedLanguage',
      caches: ['localStorage', 'cookie'],
    },
    
    react: {
      useSuspense: true,
    },
    
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;